import { v7 as uuidv7 } from "uuid";
import { z } from "zod";
import { quantitySchema } from "./quantity";

export const icJCTInfoSchema = z.object({
  id: z.string().uuid(),
  quantityId: quantitySchema.shape.id,
  drawingImageId: z.string().uuid(),
  positionX: z.number(),
  positionY: z.number(),
});

export const newIcJCTInfoInputSchema = icJCTInfoSchema.omit({
  id: true,
});

export const editIcJCTInfoInputSchema = icJCTInfoSchema.pick({
  positionX: true,
  positionY: true,
});

export type IcJCTInfo = z.infer<typeof icJCTInfoSchema>;
export type IcJCTInfoInput = z.input<typeof icJCTInfoSchema>;
export type NewIcJCTInfoInput = z.input<typeof newIcJCTInfoInputSchema>;

export const createIcJCTInfo = (input: NewIcJCTInfoInput): IcJCTInfo => {
  return newIcJCTInfo({
    ...input,
    id: uuidv7(),
  });
};

export const newIcJCTInfo = (input: IcJCTInfoInput): IcJCTInfo => icJCTInfoSchema.parse(input);
